import { Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useDialog } from "lib/@hooks/useDialog"
import { AuthoringLegislationSelectorDialog } from "../components/authoring-legislation-selector-dialog"
import { useScheduleEditorActions } from "./hooks/use-schedule-editor-actions"

export function AddLegislationButton() {
    const { target } = useBoundContext()
    const { notifyDraftStructureChanged, flushDraftBeforeSave } = useScheduleEditorActions()
    // Pass the draft's raw id array, not the display-resolved legislation objects — the dialog keys on legacyId.
    const dialog = useDialog(<AuthoringLegislationSelectorDialog group={{ legislation: target.legislation ?? [] }} />, {
        maxWidth: "md",
    })
    return (
        <Button sx={{ mt: 2 }} color="primary" onClick={add} id="add-guidance" data-cy="schedule-editor-add-reference">
            + Add Reference
        </Button>
    )

    async function add() {
        const selected = await dialog()
        if (selected) {
            target.legislation = selected
            notifyDraftStructureChanged?.()
            // Persist immediately — otherwise a refresh inside the autosave debounce window loses the reference.
            await flushDraftBeforeSave?.()
        }
    }
}
